import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { AssignableUserProfile } from '@savgroup-front-common/core/api/Authorization/listUserProfileQuery';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}users/listUserProfile`;

export interface ListUserProfileQueryArgs {
  tenantId: string;
}

export const listUserProfileRequest = (
  payload: ListUserProfileQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(
    ENDPOINT,
    { tenantId: payload.tenantId },
    { skipNulls: true },
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

export const listUserProfileQuery = async (
  payload: ListUserProfileQueryArgs,
): Promise<BackResponse<AssignableUserProfile[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<AssignableUserProfile[]>>(
      listUserProfileRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
